export const DEFAULT_MUSIC_PLAYBACK = true;
export const DEFAULT_SOUND_EFFECTS = true;
export const DEFAULT_HINTS_EFFECTS = true;
export const DEFAULT_COUNTDOWN = true;
export const DEFAULT_BADGE_NOTIFICATIONS = true;
export const DEFAULT_FONT_SIZE = 16;
export const DEFAULT_HIGH_CONTRAST = true;
